import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MapService } from 'src/app/services/map/map.service';
import { AccountService } from 'src/app/services/account/account.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';
import { MobileResolutionService } from 'src/app/services/platform/mobile-resolution.service';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';
import { VehicleImageFallbackDirective } from 'src/app/directives/vehicle-image-fallback.directive';

@Component({
  standalone: true,
  selector: 'app-vehicle-header',
  templateUrl: './vehicle-header.component.html',
  styleUrls: ['./vehicle-header.component.scss'],
  imports: [CommonModule, VehicleImageFallbackDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleHeaderComponent {

  @Input() navigation: boolean = false;
  @Input() selectedCarNameString: string = '';
  @Input() selectedCarMultilineString: string = '';
  @Input() manageVehicles: boolean = false;

  constructor(
    public mapService: MapService,
    private settingsService: SettingsService,
    private cdr: ChangeDetectorRef,
    private destroyRef: DestroyRef,
    public vehicleService: VehicleService
  ) {
  }
}
